import { __awaiter } from "tslib";
const getCodeVerifier = () => {
    const array = new Uint32Array(28);
    crypto.getRandomValues(array);
    return Array.from(array, (dec) => `0${dec.toString(16)}`.slice(-2)).join('');
};
const getCodeChallenge = (codeVerifier) => __awaiter(void 0, void 0, void 0, function* () {
    const digest = yield crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
});
export const getPkceChallenge = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!crypto) {
        throw new Error('Cannot generate PKCE challenge params, crypto API is unavailable.');
    }
    const codeVerifier = getCodeVerifier();
    const codeChallenge = yield getCodeChallenge(codeVerifier);
    return { codeChallenge, codeVerifier };
});
//# sourceMappingURL=getPkceChallenge.js.map